module.exports = "<app-research [popUpMode]=\"true\"></app-research>"